import type { MouseEventHandler } from 'react'
import React, { useCallback } from 'react'
import { useIntl } from 'react-intl'
import TextButton from 'LuxKit/Button/TextButton'
import type { OfferPageFilterType } from 'contexts/OfferPage/offerPageStateReducer'

type FilterType = Extract<OfferPageFilterType, 'airport' | 'checkin'>

function mapToFilterType(filter: string | undefined): FilterType {
  switch (filter) {
    case 'airport':
    case 'checkin':
      return filter
    default:
      throw new Error(`Unknown filter type: ${filter}`)
  }
}

interface Props {
  shouldChangeAirport: boolean
  shouldChangeDepartureDate: boolean
  onToggleFilter: (filter: FilterType) => void
}

function PropertyUnavailableRateOptionCtas({
  shouldChangeAirport,
  shouldChangeDepartureDate,
  onToggleFilter,
}: Props) {
  const intl = useIntl()
  const onClick = useCallback<MouseEventHandler<HTMLButtonElement>>(event => {
    onToggleFilter(mapToFilterType(event.currentTarget.dataset.filter))
  }, [onToggleFilter])

  return <>
    {shouldChangeAirport && <TextButton
      onClick={onClick}
      kind="tertiary"
      size="large"
      data-filter="airport"
    >
      {intl.formatMessage({
        id: 'O61MXPt04oubaI9fHQIk',
        defaultMessage: 'Change airport',
        description: 'Button text to change departure airport for property rate option',
      })}
    </TextButton>}
    {shouldChangeDepartureDate && <TextButton
      onClick={onClick}
      kind="tertiary"
      size="large"
      data-filter="checkin"
    >
      {intl.formatMessage({
        id: '7Zu7_Ey3tyz7G9y8Tnlq',
        defaultMessage: 'Change departure date',
        description: 'Button text to change departure date for property rate option',
      })}
    </TextButton>}
  </>
}

export default React.memo(PropertyUnavailableRateOptionCtas)
